import Toggler from './toggler-component';

const MODULE_NAME = 'app.common.widgets.toggler';
const module = angular.module(MODULE_NAME, [])
    .directive(Toggler.DIRECTIVE_NAME, Toggler);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/toggler/toggler-module.js